export default [
  {
    id: 'nav-video-generation',
    title: 'Herotive AI',
    icon: 'VideoIcon',
    route: 'video-generation',
    children: [
      {
        title: 'Video generator',
        route: 'CreateCampaignVideo',
      },
      {
        title: 'Video library',
        route: 'GeneratedLibrary',
      },
    ],
  },
]
